var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyHydrateSsr',[_c('div',{attrs:{"data-status":_vm.status,"data-placement":_vm.placement},domProps:{"innerHTML":_vm._s(_vm.creativeHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }